import * as React from 'react';
import { useEffect, useState } from 'react';

/** Router Packages. */
import { useNavigate } from 'react-router-dom';

/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/** Date & Time converting library. */
import dayjs from 'dayjs';

/** Internal Components */
import Main from './Main';
import useUserRole from '../utils/useUserRole';

export default function RenderComponent(props) {
    /** Get props from App.js.  */
    const { dashboard, accountsetting, account, addons, myprofile } = props;

    /** Get authentication status and user information. */
    const { isAuthenticated, user, logout } = useAuth0();

    /** Navigation handler */
    const navigate = useNavigate();
    /** Get user role from useUserRole hook. */
    const userRole = useUserRole();

    /** State to track token expiration */
    const [isTokenExpired, setIsTokenExpired] = useState(false);

    /**
     * Check token expiry and set token expiry checker to True.
     * @param {Object} isTokenExpired - Token expiry state object.
     */
    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }
        const checkTokenExpiry = () => {
            const tokenExpiry = sessionStorage.getItem('exp');
            if (tokenExpiry && new Date(tokenExpiry) < dayjs()) {
                setIsTokenExpired(true);
            }
        };
        const interval = setInterval(() => {
            checkTokenExpiry();
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    /** Logout the user if the token is expired. */
    useEffect(() => {
        if (isTokenExpired) {
            logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            });
        }
    }, [isTokenExpired]);

    /** Restrict access to unauthorized users. */
    const restrictAccess = (userRole) => {
        if (!['Administrator', 'Executive'].some((role) => userRole.includes(role))) {
            return navigate('/inactive');
        }
    };

    /** Restrict access to users who are not administrators. */
    const restrictedAdminAccess = (userRole) => {
        if (!userRole.includes('Administrator')) {
            return navigate('/dashboard');
        }
        restrictAccess(userRole);
    };

    /** Effect to handle navigation based on props and userRole. */
    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }
        const handleNavigation = () => {
            switch (true) {
                case dashboard:
                case accountsetting:
                case account:
                    restrictAccess(userRole);
                    break;
                case addons:
                    restrictedAdminAccess(userRole);
                    break;
                case myprofile:
                    restrictAccess(userRole);
                    break;
                default:
                    break;
            }
        };
        handleNavigation();
    }, [userRole, dashboard, accountsetting, account, addons, myprofile, isAuthenticated]);

    return (
        <Main
            dashboard={dashboard}
            accountsetting={accountsetting}
            account={account}
            addons={addons}
            myprofile={myprofile}
        />
    );
}
